const Variant = {
  outlined: "outlined",
  standard: "standard"
};
const Size = {
  small: "small",
  medium: "medium"
};

export { Size, Variant };
//# sourceMappingURL=types.js.map
